import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const Container = styled.div.attrs({
  as: 'section',
})`
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.bg.default')};
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
`

export const PageContent = styled.div`
  overflow: hidden;
  height: 100%;
`
